import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import IMG_CLOCK_ICON from 'assets/images/clock-for-sms.svg';
import Badge from 'components/generic/Badge.component';
import Foldout from 'components/generic/Foldout.component';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { DEPOSIT_TYPE_TRANSLATION_KEYS, DEPOSIT_TYPES } from 'constants/depositType.const';
import VOUCHER_REASON_TYPE from 'constants/voucherReasonType.const';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { formatDayToYearShorter } from 'utils/date/format.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import { deleteVoucher, getAllVoucher } from 'cashup/actions';
import VoucherItem from 'vouchers/components/VoucherItem';
import VoucherSearch from 'vouchers/components/VoucherSearch.component';
import VoucherNavigation from 'vouchers/VoucherNavigation.component';

import CN from './Tracking.module.scss';

class Tracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      voucherList: null,
    };
  }

  componentDidMount() {
    this.props.getAllVoucher(this.props.salonId);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.voucherList !== this.state.voucherList) {
      this.setState({ voucherList: nextProps.voucherList });
    }
  }

  onDeleteHandler = (id) => {
    this.props.deleteVoucher(id, this.props.salonId);
    setTimeout(() => {
      this.props.getAllVoucher(this.props.salonId);
    }, 500);
  };

  showDetails = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  filterVouchers = (e) => {
    if (e.length >= 2) {
      const search = e.toLowerCase();
      const { vouchers } = this.state.voucherList;
      if (vouchers) {
        const filteredVouchers = vouchers.filter(
          (v) =>
            v.number.toLowerCase().indexOf(search) >= 0 ||
            (v.purchased_by && v.purchased_by.toLowerCase().indexOf(search) >= 0) ||
            (v.purchased_for && v.purchased_for.toLowerCase().indexOf(search) >= 0),
        );
        this.setState({ voucherList: { vouchers: filteredVouchers } });
      }
    } else {
      this.setState({ voucherList: this.props.voucherList });
    }
  };

  render() {
    const { isDarkMode, voucherList, t } = this.props;

    let sortedVouchers = [];
    if (this.state.voucherList && this.state.voucherList.vouchers) {
      sortedVouchers = this.state.voucherList.vouchers.sort((a, b) => (a.created_at > b.created_at ? 1 : -1)).reverse();
    }

    const componentClasses = cn({
      [CN.component]: true,
      [CN.darkMode]: isDarkMode,
    });

    return (
      <div data-bem="Tracking" className={componentClasses}>
        <VoucherNavigation salonId={this.props.salonId} history={this.props.history} />

        {fromAnyToBool(voucherList) && (
          <VoucherSearch
            totalValue={voucherList.total_vouchers_amount}
            validValue={voucherList.valid_vouchers_amount}
            totalCount={voucherList.total_vouchers_count}
            validCount={voucherList.valid_vouchers_count}
            onChange={(e) => this.filterVouchers(e.target.value)}
          />
        )}

        {fromAnyToBool(voucherList) ? (
          <div className={CN.container}>
            <Foldout tag="Tracking" title={t('voucherTracking.foldoutTitle')} isOpen>
              <div className={CN.scrollContainer}>
                <div className={CN.tableHeader}>
                  <div className={CN.headerContainer}>
                    <div className={CN.cell1}>{t('voucherTracking.tableHeaders.dateIssued')}</div>
                    <div className={CN.cell2}>{t('voucherTracking.tableHeaders.code')}</div>
                    <div className={CN.cell3}>{t('voucherTracking.tableHeaders.amountRemaining')}</div>
                    <div className={CN.cell4}>{t('voucherTracking.tableHeaders.purchasedBy')}</div>
                    <div className={CN.cell5}>{t('voucherTracking.tableHeaders.paymentMethod')}</div>
                    <div className={CN.cell6}>{t('voucherTracking.tableHeaders.status')}</div>
                    <div className={CN.cell7}>{t('voucherTracking.tableHeaders.expiryDate')}</div>
                    <div className={CN.cell8} />
                  </div>
                </div>

                <div className={CN.detailsContainer}>
                  {sortedVouchers.map((voucher, index) => {
                    const customerName = voucher.purchased_by || t('voucherTracking.unknown');

                    return (
                      <div key={createNodeKey({ index, tag: voucher?.id })}>
                        {fromAnyToBool(voucher.number) && (
                          <VoucherItem
                            id={voucher.id}
                            key={voucher.id}
                            created={formatDayToYearShorter(voucher.created_at)} //TODO: date localisation
                            number={voucher.number}
                            amount={voucher.amount}
                            purchased={customerName}
                            paymentType={t(DEPOSIT_TYPE_TRANSLATION_KEYS[voucher.source])}
                            state={voucher.state}
                            //TODO: date localisation
                            expires={
                              voucher.expires_at !== null ? formatDayToYearShorter(voucher.expires_at) : <div>-</div>
                            }
                            hideDeleteButton={
                              voucher.source === DEPOSIT_TYPES.ONLINE || voucher.source === DEPOSIT_TYPES.SLICK_POS
                            }
                            onDeleteHandler={() => this.onDeleteHandler(voucher.id)}
                          >
                            <div className={CN.containerHistory}>
                              <div className={CN.titleHistory}>
                                <img src={IMG_CLOCK_ICON} alt="Clock icon" className={CN.icon} />
                                <span>{t('voucherTracking.voucherItem.tableTitle')}</span>
                              </div>
                              <div className={CN.headerHistory}>
                                <div className={CN.item}>{t('voucherTracking.tableHeaders.date')}</div>
                                <div className={CN.item}>{t('voucherTracking.tableHeaders.lastAction')}</div>
                                <div className={CN.item}>{t('voucherTracking.tableHeaders.amount')}</div>
                                <div className={CN.item}>{t('voucherTracking.tableHeaders.remainingBalance')}</div>
                                <div className={CN.item} />
                              </div>

                              {voucher.changes
                                .map((v) => (
                                  <div className={CN.contentHistory} key={v.created_at}>
                                    {/* TODO: date localisation */}
                                    <div className={CN.item}>{formatDayToYearShorter(v.created_at)}</div>
                                    <div className={CN.item}>
                                      <div className={CN.statusContainer}>
                                        {v.reason === VOUCHER_REASON_TYPE.created && (
                                          <Badge name={t('composite.badge.created')} variant="fine" />
                                        )}
                                        {v.reason === VOUCHER_REASON_TYPE.used && (
                                          <Badge name={t('composite.badge.used')} variant="draft" />
                                        )}
                                        {v.reason === VOUCHER_REASON_TYPE.void && (
                                          <Badge name={t('composite.badge.reactivated')} variant="success" />
                                        )}
                                      </div>
                                    </div>
                                    <div className={CN.item}>
                                      <CurrencySign value={v.amount_change} />
                                    </div>
                                    <div className={CN.item}>
                                      <CurrencySign value={v.amount_after_change} />
                                    </div>
                                    <div className={CN.item} />
                                  </div>
                                ))
                                .reverse()}
                            </div>
                          </VoucherItem>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Foldout>
          </div>
        ) : (
          <OverlaySpinner />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state?.cashup?.voucherList,
  salonId: state?.currentSalon?.id,
  voucherList: state?.cashup?.voucherList,
  isFetching: state?.cashup?.isFetching,
});

const mapDispatchToProps = (dispatch) => ({
  getAllVoucher(salonId) {
    dispatch(getAllVoucher(salonId));
  },
  deleteVoucher(id, salonId) {
    dispatch(deleteVoucher(id, salonId));
  },
});

const TrackingHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withTheme()(Tracking)));

export default TrackingHoc;
